import styles from './SectionTitle.module.css';

const SectionTitle = ({ children }) => {
    return (
        <div className={styles.title}>
            <h2>{children}</h2>
            <hr />
        </div>
    );
};

export default SectionTitle;
